import React from "react";

function getCellDisplayValue(cell) {
  const v = cell.value;

  if (v === null || v === undefined) return "";

  // plain
  if (typeof v === "string" || typeof v === "number" || typeof v === "boolean") {
    return v;
  }

  // formula
  if (v.formula) return v.result ?? "";

  // rich text
  if (v.richText) return v.richText.map((t) => t.text).join("");

  // hyperlink
  if (v.text) return v.text;

  // date
  if (v instanceof Date) return v.toLocaleDateString();

  return "";
}

export default function ExcelSheetPreviewer({ worksheet, onCellClick, mappedCells = {} }) {
  if (!worksheet) return null;

  const merges = worksheet._merges || {};

  const isMerged = (r, c) => {
    for (let k in merges) {
      const m = merges[k];

      if (r >= m.top && r <= m.bottom && c >= m.left && c <= m.right) {
        return m;
      }
    }

    return null;
  };

  const getStyle = (cell) => {
    const s = cell.style || {};

    return {
      fontWeight: s.font?.bold ? "bold" : "normal",

      fontSize: s.font?.size ? `${s.font.size}px` : "12px",

      textAlign: s.alignment?.horizontal,

      verticalAlign: s.alignment?.vertical,

      background: s.fill?.fgColor?.argb ? `#${s.fill.fgColor.argb.slice(2)}` : "white",

      border: s.border ? "1px solid #ccc" : "none",
    };
  };

  const rows = [];

  worksheet.eachRow({ includeEmpty: true }, (row, r) => {
    const cols = [];

    row.eachCell({ includeEmpty: true }, (cell, c) => {
      const merge = isMerged(r, c);

      if (merge && (r !== merge.top || c !== merge.left)) return;

      const addr = cell.address;

      const mapped = mappedCells[addr];

      cols.push(
        <td
          key={addr}
          data-cell={addr}
          rowSpan={merge ? merge.bottom - merge.top + 1 : 1}
          colSpan={merge ? merge.right - merge.left + 1 : 1}
          style={{
            ...getStyle(cell),

            width: worksheet.getColumn(c)?.width * 8,

            height: worksheet.getRow(r)?.height,

            cursor: "pointer",

            userSelect: "none",

            background: mapped ? "#fff3cd" : getStyle(cell).background,

            border: mapped ? "2px solid orange" : "1px solid #ddd",
          }}
          contentEditable={false}
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();

            onCellClick(addr);
          }}
        >
          {getCellDisplayValue(cell)}
        </td>
      );
    });

    rows.push(<tr key={r}>{cols}</tr>);
  });

  return (
    <div
      style={{
        overflow: "auto",
        userSelect: "none",
      }}
    >
      <table
        style={{
          borderCollapse: "collapse",
        }}
      >
        <tbody>{rows}</tbody>
      </table>
    </div>
  );
}
